import * as Types from '../../../graphql/generated-base';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetContactCollectorGroupDetailsByPersonIdQueryVariables = Types.Exact<{
  contactCollectionId: Types.Scalars['ID'];
  eventId: Types.Scalars['ID'];
  personId: Types.Scalars['ID'];
}>;

export type GetContactCollectorGroupDetailsByPersonIdQuery = {
  __typename?: 'Query';
  getContactCollectorGroupDetailsByPersonId?: {
    __typename?: 'ContactCollectorGroupDetails';
    party?: string | null;
    contacts: Array<{
      __typename?: 'Contact';
      id: string;
      firstName: string;
      lastName: string;
      email?: string | null;
      householdId: string;
      phoneNumber?: Array<{ __typename?: 'ContactPhoneNumber'; id: string; number: string; mobile: boolean; allowSMS: boolean } | null> | null;
      household?: {
        __typename?: 'ContactHousehold';
        id: string;
        address?: {
          __typename?: 'ContactAddress';
          id: string;
          address1: string;
          address2?: string | null;
          city: string;
          region: string;
          postalCode: string;
          country: string;
          countryCode: string;
          validated: boolean;
        } | null;
      } | null;
    }>;
  } | null;
};

export type UpdateContactForContactCollectorMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  data: Types.ContactInput;
}>;

export type UpdateContactForContactCollectorMutation = { __typename?: 'Mutation'; updateContact: { __typename?: 'Contact'; id: string; householdId: string } };

export const GetContactCollectorGroupDetailsByPersonIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetContactCollectorGroupDetailsByPersonId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactCollectionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'personId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getContactCollectorGroupDetailsByPersonId' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'contactCollectionId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'contactCollectionId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'personId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'personId' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'party' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'householdId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumber' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mobile' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'allowSMS' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'household' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'validated' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetContactCollectorGroupDetailsByPersonIdQuery__
 *
 * To run a query within a React component, call `useGetContactCollectorGroupDetailsByPersonIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactCollectorGroupDetailsByPersonIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactCollectorGroupDetailsByPersonIdQuery({
 *   variables: {
 *      contactCollectionId: // value for 'contactCollectionId'
 *      eventId: // value for 'eventId'
 *      personId: // value for 'personId'
 *   },
 * });
 */
export function useGetContactCollectorGroupDetailsByPersonIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetContactCollectorGroupDetailsByPersonIdQuery, GetContactCollectorGroupDetailsByPersonIdQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetContactCollectorGroupDetailsByPersonIdQuery, GetContactCollectorGroupDetailsByPersonIdQueryVariables>(
    GetContactCollectorGroupDetailsByPersonIdDocument,
    baseOptions,
  );
}
export function useGetContactCollectorGroupDetailsByPersonIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactCollectorGroupDetailsByPersonIdQuery, GetContactCollectorGroupDetailsByPersonIdQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetContactCollectorGroupDetailsByPersonIdQuery, GetContactCollectorGroupDetailsByPersonIdQueryVariables>(
    GetContactCollectorGroupDetailsByPersonIdDocument,
    baseOptions,
  );
}
export type GetContactCollectorGroupDetailsByPersonIdQueryHookResult = ReturnType<typeof useGetContactCollectorGroupDetailsByPersonIdQuery>;
export type GetContactCollectorGroupDetailsByPersonIdLazyQueryHookResult = ReturnType<typeof useGetContactCollectorGroupDetailsByPersonIdLazyQuery>;
export type GetContactCollectorGroupDetailsByPersonIdQueryResult = Apollo.QueryResult<
  GetContactCollectorGroupDetailsByPersonIdQuery,
  GetContactCollectorGroupDetailsByPersonIdQueryVariables
>;
export const UpdateContactForContactCollectorDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateContactForContactCollector' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ContactInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateContact' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'data' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'householdId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateContactForContactCollectorMutationFn = Apollo.MutationFunction<UpdateContactForContactCollectorMutation, UpdateContactForContactCollectorMutationVariables>;

/**
 * __useUpdateContactForContactCollectorMutation__
 *
 * To run a mutation, you first call `useUpdateContactForContactCollectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactForContactCollectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactForContactCollectorMutation, { data, loading, error }] = useUpdateContactForContactCollectorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContactForContactCollectorMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateContactForContactCollectorMutation, UpdateContactForContactCollectorMutationVariables>,
) {
  return ApolloReactHooks.useMutation<UpdateContactForContactCollectorMutation, UpdateContactForContactCollectorMutationVariables>(
    UpdateContactForContactCollectorDocument,
    baseOptions,
  );
}
export type UpdateContactForContactCollectorMutationHookResult = ReturnType<typeof useUpdateContactForContactCollectorMutation>;
export type UpdateContactForContactCollectorMutationResult = Apollo.MutationResult<UpdateContactForContactCollectorMutation>;
export type UpdateContactForContactCollectorMutationOptions = Apollo.BaseMutationOptions<
  UpdateContactForContactCollectorMutation,
  UpdateContactForContactCollectorMutationVariables
>;
